import React from 'react';

interface RolesContextType {
  availableRoles: FleetOps.RoleDefinition[];
  primaryRoles: FleetOps.RoleDefinition[];
  grantableRoles: FleetOps.RoleDefinition[];
  additionalRoles: FleetOps.RoleDefinition[];
  currentPermissions: FleetOps.Permission[];
  currentRoles: FleetOps.Role[];
  isLoading: boolean;
}

const DEFAULT_ROLES_CONTEXT = {
  availableRoles: [],
  primaryRoles: [],
  grantableRoles: [],
  additionalRoles: [],
  currentPermissions: [],
  currentRoles: [],
  isLoading: true,
};

const RolesContext = React.createContext<RolesContextType>(
  DEFAULT_ROLES_CONTEXT,
);

export default RolesContext;
